var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    transform: "rotate(-180 48 48)",
    fill: "#F9A21B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3881 33.2223C53.3699 32.2515 54.9528 32.2604 55.9236 33.2422L68.7777 46.2422C69.7408 47.2162 69.7408 48.7838 68.7777 49.7578L55.9236 62.7578C54.9528 63.7396 53.3699 63.7485 52.3881 62.7777C51.4063 61.8069 51.3974 60.224 52.3682 59.2422L61.0123 50.5H31C29.6193 50.5 28.5 49.3807 28.5 48C28.5 46.6193 29.6193 45.5 31 45.5H61.0123L52.3682 36.7578C51.3974 35.776 51.4063 34.1931 52.3881 33.2223Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton);
export default __webpack_public_path__ + "static/media/BUTTON.6bb4c794f2d7c79f11a86efa59041ec2.svg";
export { ForwardRef as ReactComponent };